"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = exports.setOpen = exports.get = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
// import { stevieTexts2 } from '@uiParts/stevieTexts2-sidecar'
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    return {
        isOpen: true,
    };
};
var setOpen = function (isOpen) {
    var obj = get();
    obj.isOpen = isOpen;
};
exports.setOpen = setOpen;
var render = function () {
    var obj = get();
    if (!obj.isOpen)
        return;
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var x = gb.width - 200;
    var y = 20;
    var w = 500;
    var h = 300;
    var sy = y;
    var sx = x;
    var addText = function (text, ox, oy) {
        if (ox === void 0) { ox = 0; }
        if (oy === void 0) { oy = 0; }
        diveFont_sidecar_1.diveFont.writeAbsolute(x + ox, y + oy, text, 0.5, diveColors_1.diveColors.pureWhite);
        y += 20;
    };
    var addSpacer = function () {
        y += 30;
    };
    addText('WS: ' +
        websockets_sidecar_1.websockets.getConnectionStatus() +
        ' (' +
        (websockets_sidecar_1.websockets.getIsHost() ? 'Host' : 'Client') +
        ')');
    if (websockets_sidecar_1.websockets.getConnectionStatus() === 'Open') {
        addText('Game: ' + websockets_sidecar_1.websockets.getChannel());
        addText('Id: ' + websockets_sidecar_1.websockets.getMultiId() + ' - ' + websockets_sidecar_1.websockets.getMultiName());
        var ping = websockets_sidecar_1.websockets.getPingTime();
        if (ping >= 999) {
            ping = '-';
        }
        else {
            ping = ping + ' ms';
        }
        addText('Ping: ' + ping);
    }
};
exports.render = render;
